import { axiosInstanceV2 } from "./AxiosInstance"

const API_URL = "/modulestoapps"

export const getModulesToApps = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let queryParams = `?limit=${limit}&page=${page}`
    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`
    }
    if (searchField) {
      queryParams += `&searchField=${searchField}`
    }
    const response = await axiosInstanceV2.get(`${API_URL}${queryParams}`)
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching modules to apps", error)
    throw error
  }
}

export const createModuleToApp = async (moduleToAppData) => {
    try {
        const response = await axiosInstanceV2.post(API_URL, moduleToAppData);
        return response.data;
    } catch (error) {
        console.error("Error creating module to app", {
            error: error.response?.data,
            requestData: moduleToAppData,
        });
        throw error;
    }
}
export const updateModuleToApp = async (moduleToAppId, moduleToAppData) => {
    try {
        const response = await axiosInstanceV2.put(`${API_URL}/${moduleToAppId}`, moduleToAppData);
        return response.data;
    } catch (error) {
        console.error("Error updating module to app", error);
        throw error;
    }
}
export const deleteModuleToApp = async (moduleToAppId) => {
    try {
        const response = await axiosInstanceV2.delete(`${API_URL}/${moduleToAppId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting module to app", error);
        throw error;
    }
}
export const getModuleToAppById = async (moduleToAppId) => {
    try {
        const response = await axiosInstanceV2.get(`${API_URL}/${moduleToAppId}`);
        return {
            data: response.data.data,
            status: response.status,
            message: response.data.message,
        };
    } catch (error) {
        console.error("Error fetching module to app by ID", error);
        throw error;
    }
}
